import { useNavigate } from 'react-router-dom';

import { Text, Button } from '@comicrelief/component-library';

import { logger } from '@/services/logger/logger';

import StepBack from '@/components/stepBack/StepBack';

function NotFound() {
  const navigate = useNavigate();

  logger.warn('Not found page accessed');

  const navigateHome = () => {
    void navigate('/');
  };

  return (
    <>
      <Text tag="h1" family="Anton" size="xxl" color="black">Not Found</Text>

      <p>The page you attempted to access could not be found.</p>

      <Button
        type="submit"
        onClick={navigateHome}
      >
        Return home
      </Button>

      <StepBack />
    </>
  );
}

export default NotFound;
